import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Services: [
      { name: 'A.I. Agent Deployment', href: '/services' },
      { name: 'Lead Generation A.I.', href: '/services' },
      { name: 'Process Automation', href: '/services' },
      { name: 'Client Experience A.I.', href: '/services' }
    ],
    Company: [
      { name: 'About Us', href: '/about' },
      { name: 'Case Studies', href: '/case-studies' },
      { name: 'Contact', href: '/contact' }
    ],
    Industries: [
      { name: 'Health & Wellness', href: '/services' },
      { name: 'Home Services', href: '/services' },
      { name: 'Finance', href: '/services' },
      { name: 'Professional Services', href: '/services' }
    ]
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/b707cfd433a617e1875a5534fdf7e3a2.png" 
                alt="Talynt AI" 
                className="h-16 mb-4"
              />
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              Build an intelligent business with A.I. agents that work for you 24/7.
            </p>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
                {category}
              </h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-600">
              © {currentYear} Talynt AI. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-sm text-gray-500 hover:text-blue-600 transition-colors duration-200"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
